import React from 'react'
import { Redirect, Route, Switch } from 'react-router'

import FuturePaymentsList from './FuturePaymentsList'

export default function FuturePayments() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/pagos_programados" component={FuturePaymentsList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}